export default __webpack_public_path__ + "static/media/Template-Sample.6ae2ab68.csv";